import ReplaceDocUploader from './ReplaceDocUploader';

export default ReplaceDocUploader;